<template>
  <div class="resize-item" tabindex="0" @focus='focusAction' @blur='blurAction' :style="{'z-index': focusFlag ? 80 : 0}" ref='resizeItem'>
    <div
      class="select-panel"
      @click='showView = !showView'
      tabindex="0"
      @blur="toggleBlurAction"
      :class="{'select-panel-down':!showView, 'select-panel-up':showView}"
    >
      <!-- <i class="el-collapse-item__arrow el-icon-arrow-right" :class="{'is-active':showView = showView}"></i> -->
      <ul class="select-ul" v-show='showView'>
        <li v-for='(item, index) in viewList' @click='changeView(item)' :key='index'>
          <img :src="item.image">
          <span :class="{'fontBold': item.code === seletedView}">{{$t(item.title)}}</span>
        </li>
      </ul>
    </div>
    <slot></slot>
    <div class="resize-left" v-if="leftFlag" v-show="focusFlag" @mousedown="xMoveDown($event, 'left')"></div>
    <div class="resize-top" v-if="topFlag" v-show="focusFlag" @mousedown="yMoveDown($event, 'top')"></div>
    <div class="resize-right" v-if="rightFlag" v-show="focusFlag" @mousedown="xMoveDown($event, 'right')"></div>
    <div class="resize-bottom" v-if="bottomFlag" v-show="focusFlag" @mousedown="yMoveDown($event, 'bottom')"></div>
    <div class="resize-se-right-bottom" v-if="rightBottomFlag" v-show="focusFlag" @mousedown="xyMoveDown($event, 'rightBottom')"></div>
    <div class="resize-se-left-bottom" v-if="leftBottomFlag" v-show="focusFlag" @mousedown="xyMoveDown($event, 'leftBottom')"></div>
    <div class="resize-se-right-top"  v-if="rightTopFlag" v-show="focusFlag" @mousedown="xyMoveDown($event, 'rightTop')"></div>
    <div class="resize-se-left-top" v-if="leftTopFlag" v-show="focusFlag" @mousedown="xyMoveDown($event, 'leftTop')"></div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'ResizeItem',
  data () {
    return {
      moveDownFlag: false,
      yMoveDownFlag: false,
      xyMoveDownFlag: false,
      initPosition: {
        x: 0,
        y: 0
      },
      focusFlag: false,
      mountedFlag: false,
      viewList: [
        {
          image: require('../assets/parts/icon/icon_side.png'),
          title: 'T_SIDE_VIEW',
          code: 'Side View'
        },
        {
          image: require('../assets/parts/icon/icon_front.png'),
          title: 'T_FRONT_VIEW',
          code: 'Front View'
        },
        {
          image: require('../assets/parts/icon/icon_top.png'),
          title: 'T_TOP_VIEW',
          code: 'Top View'
        },
        {
          image: require('../assets/parts/icon/icon_3d.png'),
          title: 'T_3D_VIEW',
          code: '3D View'
        }
      ],
      showView: false
    }
  },

  props: ['position', 'viewType'],

  methods: {
    toggleBlurAction () {
      setTimeout(() => {
        this.showView = false
      }, 100)
    },

    changeView (data) {
      let index = this.$store.state.view.findIndex((item) => item.value === this.position)
      let oldName = this.$store.state.view[index].name
      index = this.$store.state.view.findIndex((item) => item.name === data.code)
      let targetValue = this.$store.state.view[index].value
      let tempArr = JSON.parse(JSON.stringify(this.$store.state.view))
      tempArr.forEach((item) => {
        if (item.name === oldName) {
          item.value = targetValue
        } else if (item.name === data.code) {
          item.value = this.position
        }
      })
      this.$store.commit('CHANGE_VIEW', tempArr)
      // this.showView = false
      this.$nextTick(() => {
        this.$parent.$emit('resize')
      })
    },

    focusAction () {
      let index = this.$store.state.view.findIndex((item) => item.value === this.position)
      this.SET_FOCUSVIEW(this.$store.state.view[index].name)
      this.focusFlag = true
    },

    blurAction () {
      this.SET_FOCUSVIEW('')
      this.focusFlag = false
    },

    xMoveDown (e, direction) {
      this.moveDownFlag = true
      this.initPosition.x = e.pageX
      document.onmousemove = (event) => {
        this.xMove(event, direction)
      }
      document.onmouseup = (event) => {
        this.moveDownFlag = false
        document.onmousemove = null
      }
    },

    xMove (e, direction) {
      if (this.moveDownFlag) {
        let moveX = e.pageX - this.initPosition.x
        let temp = direction === 'left' ? this.$refs.resizeItem.offsetWidth - moveX : this.$refs.resizeItem.offsetWidth + moveX
        if (temp > this.$parent.$refs.resizePanel.offsetWidth - 20) {
          temp = this.$parent.$refs.resizePanel.offsetWidth - 20
        } else if (temp < 20) {
          temp = 20
        }
        this.$emit('changeSize', {
          widthData: temp + 'px',
          position: this.position,
          action: 'xMove'
        })
        this.initPosition.x = e.pageX
      }
    },

    yMoveDown (e, direction) {
      this.moveDownFlag = true
      this.initPosition.y = e.pageY
      document.onmousemove = (event) => {
        this.yMove(event, direction)
      }
      document.onmouseup = (event) => {
        this.moveDownFlag = false
        document.onmousemove = null
      }
    },

    yMove (e, direction) {
      if (this.moveDownFlag) {
        let moveY = e.pageY - this.initPosition.y
        let temp = direction === 'top' ? this.$refs.resizeItem.offsetHeight - moveY : this.$refs.resizeItem.offsetHeight + moveY
        if (temp > this.$parent.$refs.resizePanel.offsetHeight - 20) {
          temp = this.$parent.$refs.resizePanel.offsetHeight - 20
        } else if (temp < 20) {
          temp = 20
        }
        this.$emit('changeSize', {
          heightData: temp + 'px',
          position: this.position,
          action: 'yMove'
        })
        this.initPosition.y = e.pageY
      }
    },

    xyMoveDown (e, direction) {
      this.moveDownFlag = true
      this.initPosition.x = e.pageX
      this.initPosition.y = e.pageY
      document.onmousemove = (event) => {
        this.xyMove(event, direction)
      }
      document.onmouseup = (event) => {
        this.moveDownFlag = false
        document.onmousemove = null
      }
    },

    xyMove (e, direction) {
      if (this.moveDownFlag) {
        let moveX = e.pageX - this.initPosition.x
        let moveY = e.pageY - this.initPosition.y
        let tempX
        let tempY
        if (direction === 'rightBottom' || direction === 'rightTop') {
          tempX = this.$refs.resizeItem.offsetWidth + moveX
        } else {
          tempX = this.$refs.resizeItem.offsetWidth - moveX
        }
        if (direction === 'rightBottom' || direction === 'leftBottom') {
          tempY = this.$refs.resizeItem.offsetHeight + moveY
        } else {
          tempY = this.$refs.resizeItem.offsetHeight - moveY
        }
        if (tempX > this.$parent.$refs.resizePanel.offsetWidth - 20) {
          tempX = this.$parent.$refs.resizePanel.offsetWidth - 20
        } else if (tempX < 20) {
          tempX = 20
        }
        if (tempY > this.$parent.$refs.resizePanel.offsetHeight - 20) {
          tempY = this.$parent.$refs.resizePanel.offsetHeight - 20
        } else if (tempY < 20) {
          tempY = 20
        }
        this.$emit('changeSize', {
          widthData: tempX + 'px',
          heightData: tempY + 'px',
          position: this.position,
          action: 'xyMove'
        })
        this.initPosition.x = e.pageX
        this.initPosition.y = e.pageY
      }
    },

    ...mapMutations([
      'SET_FOCUSVIEW'
    ])
  },

  computed: {
    leftFlag () {
      return this.position === 'right-top' || this.position === 'right-down'
    },

    rightFlag () {
      return (this.position === 'left-top' || this.position === 'left-down') && this.viewType !== 'towY' && this.viewType !== 'one'
    },

    topFlag () {
      return this.position === 'left-down' || this.position === 'right-down'
    },

    bottomFlag () {
      return (this.position === 'left-top' || this.position === 'right-top') && this.viewType !== 'towX' && this.viewType !== 'one'
    },

    rightBottomFlag () {
      return this.position === 'left-top' && this.viewType === 'full'
    },

    leftBottomFlag () {
      return this.position === 'right-top' && this.viewType !== 'towX'
    },

    rightTopFlag () {
      return this.position === 'left-down' && this.viewType !== 'towY'
    },

    leftTopFlag () {
      return this.position === 'right-down'
    },

    seletedView () {
      let index = this.$store.state.view.findIndex(item => item.value === this.position)
      return this.$store.state.view[index].name
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.resize-item {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-left: none;
  overflow: hidden;
}

.resize-left {
  width: 7px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  cursor: e-resize;
  z-index: 90;
}

.resize-top {
  width: 100%;
  height: 7px;
  position: absolute;
  top: 0;
  cursor: s-resize;
  z-index: 90;
}

.resize-right {
  width: 7px;
  height: 100%;
  position: absolute;
  right: 0;
  cursor: e-resize;
  z-index: 90;
  top: 0;
}

.resize-bottom {
  width: 100%;
  height: 7px;
  position: absolute;
  bottom: 0;
  cursor: s-resize;
  z-index: 90;
}

.resize-se-right-bottom {
  width: 7px;
  height: 7px;
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: se-resize;
  z-index: 90;
}

.resize-se-left-bottom {
  width: 7px;
  height: 7px;
  position: absolute;
  left: 0;
  bottom: 0;
  cursor: sw-resize;
  z-index: 90;
}

.resize-se-right-top {
  width: 7px;
  height: 7px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: ne-resize;
  z-index: 90;
}

.resize-se-left-top {
  width: 7px;
  height: 7px;
  position: absolute;
  left: 0;
  top: 0;
  cursor: nw-resize;
  z-index: 90;
}

.select-ul {
  list-style: none;
  width: 130px;
  position: absolute;
  right: -5px;
  top: 25px;
  text-align: center;
  z-index:111;
  font-size: 14px;
  outline: none;
  background: #e6e6e6;
  color: #606266;
}

.select-ul li {
  border-bottom: 1px solid #bdbdbd;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.select-ul li:hover {
  background: #f0f0f0;
}

.select-ul span {
  display: inline-block;
  margin-right: 10px;
}

.select-ul li img {
  float: left;
  margin-top: 5px;
}

.select-panel li {
  cursor: pointer;
}

.select-panel {
  position: absolute;
  z-index: 111;
  cursor: pointer;
  outline: none;
  width: 20px;
  height: 20px;
  top: 5px;
  right: 5px;
}

.select-panel-down {
  background: url('../assets/parts/icon/icon_arrow/down.png') no-repeat;
  background-size: contain;
}

.select-panel-up {
  background: url('../assets/parts/icon/icon_arrow/up.png') no-repeat;
  background-size: contain;
}

.fontBold {
  font-weight: 700;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/resizeItem.vue